import React, { useEffect, useState } from "react";
import { USER_DETAIL_TABS, getUserDetailTab } from "./userDetailTabConfig";
import UserP2PTab from "./tabs/UserP2PTab.jsx";
import UserTransactionsTab from "./tabs/UserTransactionsTab.jsx";
import UserPredictionsTab from "./tabs/UserPredictionsTab.jsx";

function TabPanelContent({ tabId, userId }) {
  if (tabId === "p2p") return <UserP2PTab userId={userId} />;
  if (tabId === "transaction") return <UserTransactionsTab userId={userId} />;
  if (tabId === "predictions") return <UserPredictionsTab userId={userId} />;
  const tab = getUserDetailTab(tabId);
  return (
    <p className="au-detail-tab-empty">
      {tab.label} — coming soon.
    </p>
  );
}

export default function UserDetailTabs({ userId }) {
  const [activeTab, setActiveTab] = useState(USER_DETAIL_TABS[0].id);

  useEffect(() => {
    setActiveTab(USER_DETAIL_TABS[0].id);
  }, [userId]);

  const active = getUserDetailTab(activeTab);

  return (
    <div className="au-detail-tabs">
      <div className="au-detail-tabs-head">
        <span className="au-detail-tabs-eyebrow">Member activity</span>
        <p className="au-detail-tabs-desc">
          {active.hint ? `${active.label} · ${active.hint}` : active.label}
        </p>
      </div>

      <div
        className="au-detail-tabbar"
        role="tablist"
        aria-label="Member activity surfaces"
      >
        {USER_DETAIL_TABS.map(({ id, label, hint, icon: Icon }) => {
          const selected = activeTab === id;
          return (
            <button
              key={id}
              type="button"
              role="tab"
              id={`au-tab-${id}`}
              aria-selected={selected}
              aria-controls={`au-tabpanel-${id}`}
              className={`au-detail-tab${selected ? " au-detail-tab-active" : ""}`}
              onClick={() => setActiveTab(id)}
            >
              {Icon ? <Icon size={13} strokeWidth={2.2} aria-hidden className="au-detail-tab-icon" /> : null}
              <span className="au-detail-tab-copy">
                <span className="au-detail-tab-label">{label}</span>
                {hint ? <span className="au-detail-tab-hint">{hint}</span> : null}
              </span>
            </button>
          );
        })}
      </div>

      <div
        className="au-detail-tabpanel"
        role="tabpanel"
        id={`au-tabpanel-${activeTab}`}
        aria-labelledby={`au-tab-${activeTab}`}
      >
        <TabPanelContent tabId={activeTab} userId={userId} />
      </div>
    </div>
  );
}
